import styled from 'styled-components';
import {Title as ModalTitle} from 'components/Modal/styled';

export const ActivityIndicatorWrapper = styled.div`
  width: 100%;
`;

export const ActivityImage = styled.img`
  width: 30px;
`;

export const Title = styled(ModalTitle)`
  font-size: 18px;
  margin: 10px auto 0;
  font-weight: 600;
`;
